import React from 'react';

// Catches lazy-chunk load failures (common when a returning visitor holds a
// stale index.html after a redeploy) and reloads once to fetch fresh chunks.
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    const msg = (error && (error.message || error.name)) || '';
    const isChunk = /ChunkLoadError|Loading chunk|dynamically imported module|Importing a module script failed/i.test(msg);
    if (isChunk && !sessionStorage.getItem('chunkReloaded')) {
      sessionStorage.setItem('chunkReloaded', '1');
      window.location.reload();
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch() {}

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center text-center px-4">
          <div>
            <p className="text-[#F5F5DC] text-lg mb-3">Something went wrong loading this page.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-5 py-2 rounded-full bg-[#F5F5DC] text-black text-sm hover:bg-[#e8e8c8] transition-colors"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
